// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackButton_Container__Up-I-","Text":"BackButton_Text__2iwdI","Circle":"BackButton_Circle__13pac","Chevron":"BackButton_Chevron__2Vep6"};